module.exports = __webpack_public_path__ + "static/media/alert-warning.09936c12.svg";